import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Spin,
  Table,
  Tag,
} from "antd";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

export default function Payment() {
  const [data, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState(null);
  const { loginCredintials } = useContext(ContextAPI);

  const getAllPayments = async (pageNum = 1, pageSize = 10, searchValue = null) => {
    setSpinning(true);
    try {
      const branchData = localStorage.getItem("branch");
      const branchIds = branchData ? JSON.parse(branchData).map((b) => b.id) : [];

      const res = await platformApi.post("/api/payment/company-payment/getAll", {
        page: pageNum,
        size: pageSize,
        branchId: branchIds,
        searchString: searchValue || "",
      });

      const { data } = res;
      if (data.code === 200 && data.response?.code === 200) {
        const payments = data.response.data.payments || [];
        setData(payments);
        setCount(data.response.data.count || payments.length);
      } else {
        message.error("Failed to fetch payments");
      }
    } catch (err) {
      console.error("Error fetching payments:", err);
      message.error("Error fetching payments");
    } finally {
      setSpinning(false);
    }
  };

  useEffect(() => {
    getAllPayments(page, limit, search);
  }, [page, limit, search]);

  // Dropdown menu for page size
  const getMenu = () => {
    const size = Math.min(10, Math.ceil(count / 10));
    const options = [10];
    for (let i = 2; i <= size; i++) options.push(i * 10);
    return options.map((menu) => (
      <Item
        key={menu}
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  const columns = [
    {
      title: "Date",
      key: "paymentDate",
      render: (_, record) => {
        const dateVal = record.dateOfPayment || record.createdAt;
        return dateVal ? moment(dateVal).format("DD/MM/YYYY") : "-";
      },
    },
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      render: (text) => text || "-",
    },
    {
      title: "Booking ID",
      key: "bookingId",
      render: (_, record) => {
        if (record.module === "BOOKING" || record.module === "BOOKING_PAYMENT") {
          return record.moduleId?.bookingId || record.bookingId || "-";
        }
        return record.bookingId || "-";
      },
    },
    {
      title: "Payment Type",
      key: "paymentType",
      render: (record) =>
        record.paymentMode === "Bank Transfer"
          ? `${record.paymentType} - ${record.bankDetails?.name || "-"}`
          : record.paymentType || "-",
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
      key: "billAmount",
      render: (val) => (val ? `₹${val.toLocaleString()}` : "₹0"),
    },
    {
      title: "Collected Amount",
      dataIndex: "collectedAmount",
      key: "collectedAmount",
      render: (val) => (val ? `₹${val.toLocaleString()}` : "₹0"),
    },
    {
      title: "Paid By",
      key: "paidBy",
      render: (record) => {
        if (record.module === "EXCHANGE_DUE") {
          return record.customerName || "-";
        }
        return record.paidBy?.employeeName || "-";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color =
          status === "PAID"
            ? "green"
            : status === "PENDING"
            ? "orange"
            : "red";
        return <Tag color={color}>{status || "-"}</Tag>;
      },
    },
  ];

  return (
    <div>
      {/* ===== Header Section ===== */}
      <div className="accessories-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Title style={{ margin: 0 }} level={4}>
          Payments [{count}]
          <span style={{ marginLeft: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>

        <Search
          style={{ width: "30%" }}
          placeholder="Search Payment"
          onSearch={(value) => {
            setPage(1);
            setSearch(value);
          }}
          onChange={(e) => {
            if (e.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />
      </div>

      {/* ===== Table Section ===== */}
      <Spin spinning={spinning}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            total: count,
            pageSize: limit,
            showSizeChanger: false,
            onChange: (p) => setPage(p),
          }}
        />
      </Spin>
    </div>
  );
}